// extracted by mini-css-extract-plugin
export default {"button":"ql-z","reviewSort":"rl-z"};